
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9uAPw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $9DHhW = parcelRequire("9DHhW");


var $8aF6s = parcelRequire("8aF6s");


var $bQm3c = parcelRequire("bQm3c");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7dgT3 = parcelRequire("7dgT3");


var $cl98v = parcelRequire("cl98v");


var $jHGaM = parcelRequire("jHGaM");


var $4R3wx = parcelRequire("4R3wx");

const $a5710166add0079d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorTitleRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.title.recording-already-in-progress",
        defaultMessage: "Recording already in progress"
    },
    errorTitleNotReady: {
        id: "loom-utils.error-flag.title.not-ready",
        defaultMessage: "The Loom recorder wasn\u2019t ready"
    },
    errorIncompatibleBrowser: {
        id: "loom-utils.error-flag.description.incompatible-browser",
        defaultMessage: "The browser you\u2019re currently using isn\u2019t compatible with Loom (or you could be trying to use it in private/incognito mode). <a>Which browsers are compatible?</a>"
    },
    errorThirdPartyCookieDisabled: {
        id: "loom-utils.error-flag.description.third-party-cookie-disabled",
        defaultMessage: "Check that you have third-party cookies enabled, then try again."
    },
    errorNoMediaStreamSupport: {
        id: "loom-utils.error-flag.description.no-media-stream-support",
        defaultMessage: "You might need to try a different browser. <a>Which browsers are compatible?</a>"
    },
    errorSDKNotInitialized: {
        id: "loom-utils.error-flag.description.sdk-not-initialized",
        defaultMessage: "Try to start recording again now."
    },
    errorBackendFFNotEnabledYet: {
        id: "loom-utils.error-flag.description.be-ff-not-enabled-yet",
        defaultMessage: "Loom was recently enabled. Try again in a few minutes."
    },
    errorUnexpectedAuthTokenFailure: {
        id: "loom-utils.error-flag.description.unexpected-auth-token-failure",
        defaultMessage: "Something went wrong with the Loom recorder. Try again later, or contact Atlassian Support for help."
    },
    errorLoomUserNotCreatedYet: {
        id: "loom-utils.error-flag.description.loom-user-not-created-yet",
        defaultMessage: "Loom is enabled, just give us a few minutes to set everything up. You can try recording again in a bit."
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    },
    errorRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.description.recording-already-in-progress",
        defaultMessage: "Finish your current Loom video so you can start another."
    }
});
const $a5710166add0079d$var$LoomSDKSupportLink = 'https://support.loom.com/hc/en-us/articles/360020667617-loomSDK-FAQ';
function $a5710166add0079d$var$getUnsupportedSDKErrorDescription(error) {
    if (error === 'third-party-cookies-disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorThirdPartyCookieDisabled);
    else if (error === 'no-media-streams-support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorNoMediaStreamSupport,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
    else if (error === 'incompatible-browser') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorIncompatibleBrowser,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
}
const $a5710166add0079d$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, flags: flags, resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount = false })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const [singletonLoomSDK, { initLoomSDK: initLoomSDK }] = (0, $jHGaM.useLoomEntryPointGlobalState)();
    const [isOpeningRecorder, setIsOpeningRecorder] = (0, $cozmU.useState)(false);
    const runningSDKButton = (0, $cozmU.useRef)(null);
    // the call site for openLoomRecorder might be outside of React lifecycle
    // (e.g. editor DOM button onclick) so we need to ensure we maintain reference
    const singletonLoomSDKRef = (0, $cozmU.useRef)(singletonLoomSDK);
    singletonLoomSDKRef.current = singletonLoomSDK;
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (entryPointVariant === 'BETA' || entryPointVariant === 'CO_USE') initLoomSDK({
            cloudId: cloudId,
            environment: environment,
            entryPointLocation: entryPointLocation
        });
    }, [
        initLoomSDK,
        cloudId,
        createAnalyticsEvent,
        environment,
        entryPointVariant,
        entryPointLocation
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (resetInsertFunctionOnUnmount && runningSDKButton.current && singletonLoomSDKRef.current.initializedLoomSDK) {
                singletonLoomSDKRef.current.initializedLoomSDK.updateConfig({
                    config: {
                        insertButtonText: 'Open on Loom'
                    }
                });
                runningSDKButton.current.off('insert-click');
                runningSDKButton.current.on('insert-click', (video)=>{
                    window.open(video.sharedUrl, '_blank');
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            inserted: true,
                            insertFunctionWasReset: true
                        }
                    });
                    /**
           * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
           * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
           */ createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: entryPointLocation,
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'insertVideoLink',
                            attributes: {
                                insertFunctionWasReset: true
                            }
                        }
                    }).fire();
                });
            }
        };
    }, [
        entryPointLocation,
        resetInsertFunctionOnUnmount,
        experienceTracker,
        createAnalyticsEvent
    ]);
    const openLoomRecorder = (0, $cozmU.useCallback)(async (loomRecorderParams)=>{
        if (singletonLoomSDKRef.current.initializedLoomSDK && singletonLoomSDKRef.current.initializedLoomSDK.status().state === 'active-recording') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleRecordingAlreadyInProgress),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorRecordingAlreadyInProgress)
            });
            return;
        }
        experienceTracker.start({
            name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (singletonLoomSDKRef.current.isInitializing) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleNotReady),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKNotInitialized)
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: 'SDK has not been configured yet.'
            });
            return;
        }
        // TODO CTIA- 2019: fire a clicked UI event here
        if (singletonLoomSDKRef.current.isLoomSDKSupportedError) {
            const description = $a5710166add0079d$var$getUnsupportedSDKErrorDescription(singletonLoomSDKRef.current.isLoomSDKSupportedError);
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: description
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: `SDK not supported: ${singletonLoomSDKRef.current.isLoomSDKSupportedError}.`
            });
            return;
        }
        if (!singletonLoomSDKRef.current.hasRecordingAccess) {
            const noRecordingAccessReason = singletonLoomSDKRef.current.noRecordingAccessReason;
            if (noRecordingAccessReason === 'backendFF') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorBackendFFNotEnabledYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'loom enablement in progress'
                });
            } else if (noRecordingAccessReason === 'not-created') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorLoomUserNotCreatedYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'user not created yet'
                });
            } else if (noRecordingAccessReason === 'not-mastered' || noRecordingAccessReason === 'not-mastered-enterprise') {
                // mastering for enterprise users is not available until M3
                const isMasteringFlowEnabledForEdition = noRecordingAccessReason !== 'not-mastered-enterprise';
                showModal((0, $7dgT3.NonMasteredUserModalLoader), {
                    isMasteringFlowEnabled: isMasteringFlowEnabledForEdition
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'Does not have access to record looms from Confluence.',
                    attributes: {
                        noRecordingAccessReason: noRecordingAccessReason
                    }
                });
            } else {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorUnexpectedAuthTokenFailure)
                });
                experienceTracker.fail({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    error: singletonLoomSDKRef.current.authTokenError || new Error('unexpected error from Loom auth token or Loom user status')
                });
            }
            return;
        }
        if (!singletonLoomSDKRef.current.initializedLoomSDK || !singletonLoomSDKRef.current.initializedLoomSDK.status().success) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKFailedToInitialize)
            });
            experienceTracker.fail({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                error: singletonLoomSDKRef.current.initializedLoomSDKError || new Error('Loom SDK did not successfully initialize.'),
                attributes: {
                    loomSDKSuccessStatus: singletonLoomSDKRef.current.initializedLoomSDK?.status()?.success
                }
            });
            return;
        }
        (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        setIsOpeningRecorder(true);
        createAnalyticsEvent({
            // a track event is fired once recorder is opened, this event is speficially used for monitoring in StatSig
            type: 'sendTrackEvent',
            data: {
                source: entryPointLocation,
                action: 'opened',
                actionSubject: 'loomSdkRecorder'
            }
        }).fire();
        const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current.initializedLoomSDK;
        const sdkButton = configureButton();
        updateConfig({
            config: {
                insertButtonText: loomRecorderParams ? loomRecorderParams.insertButtonText : undefined,
                entryPointName: entryPointLocation
            }
        });
        if (loomRecorderParams) sdkButton.on('insert-click', async (video_0)=>{
            // TODO CTIA-2019: fire a inserted track event here
            loomRecorderParams.onInsert(video_0.sharedUrl, video_0);
            experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    inserted: true
                }
            });
            /**
         * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
         * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
         */ createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'insertVideoLink',
                    attributes: {
                        insertFunctionWasReset: false
                    }
                }
            }).fire();
        });
        sdkButton.on('start', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingStart'
                }
            }).fire();
        });
        sdkButton.on('recording-start', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'started',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('cancel', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingCancel'
                }
            }).fire();
        });
        sdkButton.on('complete', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingComplete',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('recording-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('upload-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'uploaded',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('lifecycle-update', (lifecycleState)=>{
            if (lifecycleState === 'pre-recording') {
                (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                setIsOpeningRecorder(false);
                // `lifecycle-update` re-enters 'pre-recording' on the SDK's
                // "Record again", so this fires on every re-record — consumers
                // tracking recorder visibility (e.g. to keep a host modal
                // hidden across re-records) need each transition. Callers that
                // want a once-per-session signal (e.g. analytics) dedupe their
                // side. Failures surface via the entry-point experience since
                // this callback is part of its contract.
                try {
                    loomRecorderParams?.onRecorderVisible?.();
                } catch (error) {
                    experienceTracker.fail({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
            } else if (lifecycleState === 'closed') {
                runningSDKButton.current = null;
                // Run the consumer callback first so a throw fails the
                // entry-point experience (instead of silently succeeding
                // then swallowing the error).
                try {
                    loomRecorderParams?.onRecorderHidden?.();
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            closed: true,
                            insertFunctionDefined: loomRecorderParams !== undefined
                        }
                    });
                } catch (error_0) {
                    experienceTracker.fail({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        error: error_0 instanceof Error ? error_0 : new Error(String(error_0))
                    });
                }
            } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    cascaded: true,
                    entryPointLocation: entryPointLocation
                }
            });
        });
        sdkButton.openPreRecordPanel();
        runningSDKButton.current = sdkButton;
    }, [
        entryPointLocation,
        experienceTracker,
        flags,
        showModal,
        createAnalyticsEvent
    ]);
    return {
        openLoomRecorder: openLoomRecorder,
        isOpeningRecorder: isOpeningRecorder,
        isLoomRecorderInitialized: !singletonLoomSDKRef.current.isInitializing,
        hasRecordingAccess: singletonLoomSDKRef.current.hasRecordingAccess
    };
};
module.exports["useLoomRecorderEntryPoint"] = $a5710166add0079d$export$c8d9dc913e9e33ec;

});

parcelRegister("7dgT3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "n2Ktr",
    name: "NonMasteredUserModalLoader",
    loader: async ()=>(await (parcelRequire("iPOCX"))).NonMasteredUserModal
});
module.exports["NonMasteredUserModalLoader"] = $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f;

});

parcelRegister("iPOCX", function(module, exports) {

let $db6442fa103badb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db6442fa103badb0$var$load("hhss7"),
    $db6442fa103badb0$var$load("np2ZB")
]).then(()=>parcelRequire('6i2Ga'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("cl98v", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $dd21d598b55c38cc$export$873f91e3be81ab94 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.OPEN_LOOM_RECORDER_SDK_INTERACTION)
});
const $dd21d598b55c38cc$export$bf1068aa9f020d8f = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION)
});
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$873f91e3be81ab94;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$bf1068aa9f020d8f;

});

parcelRegister("jHGaM", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cl98v = parcelRequire("cl98v");


var $3d6VZ = parcelRequire("3d6VZ");


var $gmNpb = parcelRequire("gmNpb");


var $38NxZ = parcelRequire("38NxZ");

const $82feff28757ef801$var$initialState = {
    isInitializing: true,
    initializedLoomSDK: null,
    _hasLoomSDKInitializationStarted: false,
    hasRecordingAccess: false,
    noRecordingAccessReason: undefined,
    authTokenError: undefined,
    isLoomSDKSupportedError: undefined,
    initializedLoomSDKError: null
};


const $82feff28757ef801$var$initSDK = ({ cloudId: cloudId, environment: environment, entryPointLocation: entryPointLocation })=>async ({ getState: getState, setState: setState })=>{
        if (getState().initializedLoomSDK || getState()._hasLoomSDKInitializationStarted) // singleton: only want 1 Loom SDK instance
        return;
        setState({
            _hasLoomSDKInitializationStarted: true
        });
        (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        try {
            const { isSupported: isSupported } = await (parcelRequire("49kj1"));
            const { supported: supported, error: isLoomSDKSupportedError } = await isSupported();
            if (!supported) {
                setState({
                    isLoomSDKSupportedError: isLoomSDKSupportedError,
                    isInitializing: false
                });
                (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                return;
            }
        } catch  {
            // If SDK isSupported import/exec fails: treat as incompatible browser
            setState({
                isLoomSDKSupportedError: 'incompatible-browser',
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        const { recorderToken: recorderToken, tokenError: tokenError } = await (0, $3d6VZ.getAuthToken)();
        if (!recorderToken || tokenError) {
            const noRecordingAccessReason = await (0, $38NxZ.getNoRecordingAccessReason)(tokenError);
            setState({
                isInitializing: false,
                noRecordingAccessReason: noRecordingAccessReason,
                authTokenError: tokenError
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        setState({
            hasRecordingAccess: true
        });
        try {
            const { createInstance: createInstance } = await (parcelRequire("kZU2l"));
            const initializedLoomSDK = await createInstance((0, $gmNpb.getLoomInstanceDataByEnvironment)({
                environment: environment,
                jws: recorderToken,
                siteId: cloudId,
                entryPointName: entryPointLocation
            }));
            setState({
                initializedLoomSDK: initializedLoomSDK,
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
        } catch (err) {
            setState({
                isInitializing: false,
                initializedLoomSDKError: err
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        }
    };
const $82feff28757ef801$var$actions = {
    initLoomSDK: $82feff28757ef801$var$initSDK
};
const $82feff28757ef801$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: $82feff28757ef801$var$initialState,
    actions: $82feff28757ef801$var$actions,
    name: 'loomEntryPointGlobalStateStore'
});
const $82feff28757ef801$export$160753b85ca93fc7 = (0, $kBr4q.createHook)($82feff28757ef801$export$6f57813fe9f31bf9);
module.exports["useLoomEntryPointGlobalState"] = $82feff28757ef801$export$160753b85ca93fc7;

});

parcelRegister("3d6VZ", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $e01Lp = parcelRequire("e01Lp");


var $55UbZ = parcelRequire("55UbZ");

const $000d418a80b56fba$export$38e1f53b76ec7fed = async ()=>{
    try {
        const tokenQuery = await (0, $c0rhi.queryInterop)({
            query: (0, $e01Lp.LoomAuthTokenQuery),
            fetchPolicy: 'network-only',
            __callerPackage__: "loom-utils"
        });
        return {
            recorderToken: tokenQuery.data.loomToken?.token
        };
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return {
            tokenError: e
        };
    }
};
const $000d418a80b56fba$export$36491da625b5403b = async ()=>{
    try {
        const authStateQuery = await (0, $c0rhi.queryInterop)({
            query: (0, $55UbZ.LoomAuthStateQuery),
            __callerPackage__: "loom-utils"
        });
        return authStateQuery.data.loomUserStatus ?? undefined;
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return undefined;
    }
};
module.exports["getAuthToken"] = $000d418a80b56fba$export$38e1f53b76ec7fed;
module.exports["getAuthState"] = $000d418a80b56fba$export$36491da625b5403b;

});

parcelRegister("e01Lp", function(module, exports) {

var $ja27m = parcelRequire("ja27m");

const $eeb31b52c8d53ac0$export$68069cc596b806b = (0, $ja27m.default);
module.exports["LoomAuthTokenQuery"] = $eeb31b52c8d53ac0$export$68069cc596b806b;

});

parcelRegister("ja27m", function(module, exports) {
/**
 * @generated SignedSource<<a767a13b18c3ec998970c2ba30768a2a>>
 * @relayHash c1b04759e5b09153deee6b2b9fb9afcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374
const $4984e0489bd92eb4$var$node = function() {
    var v0 = [
        {
            "concreteType": "LoomToken",
            "kind": "LinkedField",
            "name": "loomToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "LoomAuthTokenQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "LoomAuthTokenQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c1b04759e5b09153deee6b2b9fb9afcf",
            "id": "9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374",
            "metadata": {},
            "name": "LoomAuthTokenQuery",
            "operationKind": "query",
            "text": "query LoomAuthTokenQuery{loomToken{token}}"
        }
    };
}();
$4984e0489bd92eb4$var$node.hash = "cc249b7610e84f631da05d42ccd02363";
var $4984e0489bd92eb4$export$2e2bcd8739ae039 = $4984e0489bd92eb4$var$node;
module.exports["default"] = $4984e0489bd92eb4$export$2e2bcd8739ae039;

});

parcelRegister("55UbZ", function(module, exports) {

var $bj1zQ = parcelRequire("bj1zQ");

const $80afd1194d3d0c84$export$ee3fd3c5221b99c = (0, $bj1zQ.default);
module.exports["LoomAuthStateQuery"] = $80afd1194d3d0c84$export$ee3fd3c5221b99c;

});

parcelRegister("bj1zQ", function(module, exports) {
/**
 * @generated SignedSource<<5d9434e7e3e0611c30d0a597a2a1e57f>>
 * @relayHash 92b5f865f5d3e169ae4c9331a8c93231
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63
const $c5c9d2025b35af51$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "loomUserStatus"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "LoomAuthStateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "LoomAuthStateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "92b5f865f5d3e169ae4c9331a8c93231",
            "id": "b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63",
            "metadata": {},
            "name": "LoomAuthStateQuery",
            "operationKind": "query",
            "text": "query LoomAuthStateQuery{loomUserStatus}"
        }
    };
}();
$c5c9d2025b35af51$var$node.hash = "b0b71e4c1a4d03a9f0016476ce67cefb";
var $c5c9d2025b35af51$export$2e2bcd8739ae039 = $c5c9d2025b35af51$var$node;
module.exports["default"] = $c5c9d2025b35af51$export$2e2bcd8739ae039;

});

parcelRegister("gmNpb", function(module, exports) {
const $39913087ba6f73e2$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $39913087ba6f73e2$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: 'Confluence',
            entryPointName: entryPointName
        }
    };
    if (environment === 'DEVELOPMENT') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    if (environment === 'STAGING') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.staging,
        environment: 'staging' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $39913087ba6f73e2$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
};
module.exports["getLoomInstanceDataByEnvironment"] = $39913087ba6f73e2$export$c150e4a8d8a3ab35;

});

parcelRegister("38NxZ", function(module, exports) {

var $3d6VZ = parcelRequire("3d6VZ");


var $dn8bs = parcelRequire("dn8bs");

const $0e5a08ec05b30096$var$graphqlErrorHasMessage = (error, messageMatch)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>message.includes(messageMatch));
    return false;
};
const $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE = 'Attempted to fetch Loom token without feature flag enabled';
const $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE = 'Failed to fetch loom auth token. Status code: 404';
const $0e5a08ec05b30096$export$5a9a2c39ccb5534c = async (tokenError)=>{
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE)) return 'backendFF';
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE)) {
        const authState = await (0, $3d6VZ.getAuthState)();
        if (authState === (0, $dn8bs.LoomUserStatus).NOT_FOUND) return 'not-created';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED) return 'not-mastered';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED_ENTERPRISE) return 'not-mastered-enterprise';
    }
    return 'unexpected';
};
module.exports["getNoRecordingAccessReason"] = $0e5a08ec05b30096$export$5a9a2c39ccb5534c;

});

parcelRegister("dn8bs", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $80735413f00f04fc$export$9d643cbb1392f8e6 = /*#__PURE__*/ function(LoomUserStatus) {
    LoomUserStatus["LINKED"] = "LINKED";
    LoomUserStatus["LINKED_ENTERPRISE"] = "LINKED_ENTERPRISE";
    LoomUserStatus["MASTERED"] = "MASTERED";
    LoomUserStatus["NOT_FOUND"] = "NOT_FOUND";
    return LoomUserStatus;
}({});
module.exports["LoomUserStatus"] = $80735413f00f04fc$export$9d643cbb1392f8e6;

});

parcelRegister("49kj1", function(module, exports) {

let $3057c0fc56a94a3e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3057c0fc56a94a3e$var$load("7p6A4"),
    $3057c0fc56a94a3e$var$load("2a8Ft")
]).then(()=>parcelRequire('gzwHi'));

});

parcelRegister("kZU2l", function(module, exports) {

let $f494f8e960dfdff3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f494f8e960dfdff3$var$load("7k0CW"),
    $f494f8e960dfdff3$var$load("4tD9X"),
    $f494f8e960dfdff3$var$load("96tLT"),
    $f494f8e960dfdff3$var$load("6wr18"),
    $f494f8e960dfdff3$var$load("fYEgh"),
    $f494f8e960dfdff3$var$load("9WjlD"),
    $f494f8e960dfdff3$var$load("lFmKr"),
    $f494f8e960dfdff3$var$load("eGGci"),
    $f494f8e960dfdff3$var$load("83jZ2"),
    $f494f8e960dfdff3$var$load("jfuL6"),
    $f494f8e960dfdff3$var$load("kHs7I"),
    $f494f8e960dfdff3$var$load("f7R6d"),
    $f494f8e960dfdff3$var$load("7p6A4"),
    $f494f8e960dfdff3$var$load("81e2B"),
    $f494f8e960dfdff3$var$load("jV9Gs"),
    $f494f8e960dfdff3$var$load("8GFi1"),
    $f494f8e960dfdff3$var$load("aOIZj"),
    $f494f8e960dfdff3$var$load("k0Z8C"),
    $f494f8e960dfdff3$var$load("ffEVr"),
    $f494f8e960dfdff3$var$load("br7gN"),
    $f494f8e960dfdff3$var$load("bNJC9"),
    $f494f8e960dfdff3$var$load("hvMWl"),
    $f494f8e960dfdff3$var$load("7EorR"),
    $f494f8e960dfdff3$var$load("eiF7i"),
    $f494f8e960dfdff3$var$load("cvmv4")
]).then(()=>parcelRequire('77IPU'));

});


//# sourceMappingURL=GlobalCreateContentPopoverMenu.05c697ce.js.map
